module.exports = __webpack_public_path__ + "assets/logo-purple.f28e0bb4.svg";